import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import moment from "moment";
// import ReadViewSubject from "./ReadViewSubject";
import toast from "react-hot-toast";
import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";

export default function ReadFaculty() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    CATEGORY,
    SUBJECT,
    STATUS,
    DESIGNATION,
    SEARCHTERM,
    LOCATION,
    FAPON,
    FROM,
  } = location.state || {};

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [formFields, setFormFields] = useState({
    fname: "",
    lname: "",
    phoneNumber: "",
    email: "",
    TechType: "",
    designation: "",
    DJoin: "",
    location_name: "",
    location: "",
  });
  // const [category, setCategory] = useState([]);
  // const [subject, setSubject] = useState([]);

  useEffect(() => {
    AxiosInstance.post("api/staff/view", { user_id: userId })
      .then((res) => {
        if (res.data.status === true) {
          setFormFields({
            fname: res.data.data.first_name,
            lname: res.data.data.last_name,
            phoneNumber: res.data.data.mobile_no,
            email: res.data.data.email,
            TechType:
              res.data.data.is_eligible_class === 1
                ? "Teaching"
                : "NonTeaching",
            designation: res.data.data.designation,
            location: res.data.data.staff_loc_id,
            location_name: res.data.data.staff_loc_name,
            DJoin: moment(res.data.data.aiasa_doj).format("DD/MM/YYYY"),
          });
          // let categoryArray =
          //   res.data.data.category !== "" &&
          //   res.data.data.category !== null &&
          //   res.data.data.category.split(",");
          // setCategory(categoryArray);
          // const originalData =
          //   res.data.data.subject !== null &&
          //   res.data.data.subject !== "" &&
          //   res.data.data.subject.reduce((acc, cur) => {
          //     const categoryIndex = acc.findIndex(
          //       (item) => item.category === cur.category
          //     );
          //     if (categoryIndex === -1) {
          //       acc.push({
          //         id: acc.length + 1,
          //         category: cur.category,
          //         optionSelected: [
          //           {
          //             value: cur.subject,
          //             label: cur.subject,
          //           },
          //         ],
          //       });
          //     } else {
          //       acc[categoryIndex].optionSelected.push({
          //         value: cur.subject,
          //         label: cur.subject,
          //       });
          //     }
          //     return acc;
          //   }, []);
          // setSubject(originalData);
        }
      })
      .catch((error) => {
        return error;
      });
  }, [userId]);

  const handleCInvitation = (e) => {
    AxiosInstance.post("api/staff/cancelInvite", {
      user_id: userId,
      updated_by: userid,
    })
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          handleClose();
          navigateToPreviousScreen();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const handleResend = (e) => {
    const ResendLink = {
      user_id: userId,
    };
    AxiosInstance.post("api/staff/resendInvite", ResendLink)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          navigateToPreviousScreen();
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const navigateToPreviousScreen = () => {
    navigate(`/Faculties/${FROM}`, {
      state: {
        filCate: CATEGORY,
        filSubject: SUBJECT,
        filDesign: DESIGNATION,
        filStatus: STATUS,
        filSearch: SEARCHTERM,
        filDesign: DESIGNATION,
        filLocation: LOCATION,
        fillAon: FAPON,
        filFrom: FROM
      },
    });
  };

  return (
    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Cancel Invitation"
          message="Are you sure you want to cancel the invitation?"
          onConfirm={handleCInvitation}
          onCancel={handleClose}
          confirmLable={"Yes, Cancel Now"}
        />
      )}
      <div className=" Faculty BathHeader global_container">
        <div className="row">
          <div className="col-md-12">
            <div className="row ">
              <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                <h2 className="TitleHeader">Team Members</h2>
              </div>

              <div className="col-md-8 col-12 ListBtn">
                <ul class="List-Button">
                  <li className="ListBtnItems">
                    <Link
                      to="javascript:void(0)"
                      className="secondaryButton "
                      variant="secondary"
                      onClick={navigateToPreviousScreen}
                    >
                      {`Back to ${FROM === 1 ? "Faculties" : "Staff"}`}
                    </Link>
                  </li>

                  <li class="ListBtnItems">
                    <Link
                      to={`/Faculties/addfaculty/${FROM === 1 ? 0 : 1
                        }/${userId}`}
                      className="primaryButton "
                      variant="primary"
                    >
                      {/* <span className="material-icons me-1 fs-5 align-middle text-white">
                        border_color
                      </span> */}
                      Edit {`${FROM === 1 ? "Faculty" : "Staff"}`} Profile
                    </Link>
                  </li>

                  <li class="ListBtnItems">
                    <Link
                      to="#"
                      className="primaryButton "
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handleShow();
                      }}
                    >
                      {/* <span className="material-icons me-1 fs-5 align-middle text-white">
                        delete
                      </span> */}
                      Cancel Invitation
                    </Link>
                  </li>

                  <li class="ListBtnItems">
                    <Link
                      to="#"
                      className="primaryButton "
                      variant="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        handleResend();
                      }}
                    >
                      Resend Invitation Link
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <fieldset className="mt-3">
              <legend className="w-auto">Basic Details</legend>
              <div className="row mb-3">
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> First Name</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {formFields.fname || ""}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Last Name</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {formFields.lname || ""}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Phone Number</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {formFields.phoneNumber || ""}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Email ID</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {formFields.email || ""}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset className="mt-3">
              <legend className="w-auto">Current Job Info</legend>
              <div className="row mb-3">
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Job Type</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {formFields.TechType || ""}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0">Designation</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {formFields.designation || ""}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Date of Joining</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {" "}
                      {formFields.DJoin || ""}
                    </p>
                  </div>
                </div>
                <div className="my-1 col-lg-3 col-md-3 col-12">
                  <div className="d-flex flex-column">
                    <p className="confirm_label m-0 p-0"> Branch Location</p>
                    <p className="confirm_value my-1 m-0 p-0">
                      {formFields.location_name || ""}
                    </p>
                  </div>
                </div>
              </div>
            </fieldset>

            {/* <section className="StepOne">
              {subject.length > 0 &&
                subject.map((item, index) => (
                  <ReadViewSubject
                    id={"category_" + index}
                    key={"category_key" + index}
                    record={item}
                  />
                ))}
            </section> */}
          </div>
        </div>
      </div>
    </>
  );
}
